/* ==========================================================================
   Badge de reducere pe cardurile de produs — itoz
   De salvat ca assets/custom-card-discount.js si inclus in theme.liquid:
     <script src="{{ 'custom-card-discount.js' | asset_url }}" defer></script>

   Procentul nu poate fi calculat din CSS (e o scadere intre doua preturi,
   iar in markup-ul cardului nu exista niciun element cu procentul).
   Scriptul citeste pretul vechi si pe cel nou din card si insereaza badge-ul.
   ========================================================================== */
(function () {
  'use strict';

  var BADGE_CLASS = 'card-sale-badge';
  var LINE_CLASS = 'card-price-line';

  /* "1.299,00 lei" -> 1299.00 ; "129,00 lei" -> 129
     Punctul e separator de mii in formatul RO, virgula e zecimala. */
  function toNumber(text) {
    if (!text) return null;
    var cleaned = text.replace(/[^\d.,]/g, '');
    cleaned = cleaned.replace(/\.(?=\d{3}(\D|$))/g, '');
    cleaned = cleaned.replace(',', '.');
    var n = parseFloat(cleaned);
    return isNaN(n) ? null : n;
  }

  function percent(oldPrice, newPrice) {
    if (!oldPrice || !newPrice || oldPrice <= newPrice) return null;
    return Math.round((oldPrice - newPrice) / oldPrice * 100);
  }

  function makeBadge(pct) {
    var el = document.createElement('span');
    el.className = BADGE_CLASS;
    el.setAttribute('aria-hidden', 'true');
    el.textContent = '-' + pct + '%';
    return el;
  }

  /* Pune pretul vechi si badge-ul pe acelasi rand, intr-un wrapper. */
  function wrapWithBadge(oldEl, pct) {
    var line = document.createElement('div');
    line.className = LINE_CLASS;
    oldEl.parentNode.insertBefore(line, oldEl);
    line.appendChild(oldEl);
    line.appendChild(makeBadge(pct));
    return line;
  }

  /* Varianta 1: .rc-sale + s.small */
  function processRc(root) {
    var items = root.querySelectorAll('.rc-sale');
    for (var i = 0; i < items.length; i++) {
      var newEl = items[i];
      var parent = newEl.parentNode;
      if (!parent || parent.querySelector('.' + BADGE_CLASS)) continue;

      var oldEl = parent.querySelector('s');
      if (!oldEl) continue;

      var pct = percent(toNumber(oldEl.textContent), toNumber(newEl.textContent));
      if (pct === null) continue;

      wrapWithBadge(oldEl, pct);
    }
  }

  /* Varianta 2: .product-card__price cu s.product-card__regular-price.
     Pretul curent e un nod de text simplu, deci il citim din childNodes. */
  function processCardPrice(root) {
    var boxes = root.querySelectorAll('.product-card__price');
    for (var i = 0; i < boxes.length; i++) {
      var box = boxes[i];
      if (box.querySelector('.' + BADGE_CLASS)) continue;

      var oldEl = box.querySelector('.product-card__regular-price');
      if (!oldEl) continue;

      var newText = '';
      for (var j = 0; j < box.childNodes.length; j++) {
        var node = box.childNodes[j];
        if (node.nodeType === 3 && /\d/.test(node.nodeValue)) {
          newText += node.nodeValue;
        }
      }

      var pct = percent(toNumber(oldEl.textContent), toNumber(newText));
      if (pct === null) continue;

      wrapWithBadge(oldEl, pct);
    }
  }

  function run(root) {
    root = root || document;
    try {
      processRc(root);
      processCardPrice(root);
    } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { run(); });
  } else {
    run();
  }

  /* Cardurile incarcate ulterior (filtrare, paginare AJAX, quick view). */
  if (window.MutationObserver) {
    var pending = null;
    new MutationObserver(function () {
      clearTimeout(pending);
      pending = setTimeout(function () { run(); }, 120);
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
